/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Ares_HintInputs */

const cs_property_registry_ares_hint = /** @type {(inputs: Property_Registry_Ares_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhledání firmy podle IČO, pokud je vlastník nebo protistrana právnická osoba.`)
};

const en_property_registry_ares_hint = /** @type {(inputs: Property_Registry_Ares_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Look up a company by IČO when the owner or counterparty is a legal entity.`)
};

/**
* | output |
* | --- |
* | "Look up a company by IČO when the owner or counterparty is a legal entity." |
*
* @param {Property_Registry_Ares_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_ares_hint = /** @type {((inputs?: Property_Registry_Ares_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Ares_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_ares_hint(inputs)
	return cs_property_registry_ares_hint(inputs)
});